import { render, staticRenderFns } from "./MasterDashboardLayout.vue?vue&type=template&id=4f59f84c&scoped=true"
import script from "./MasterDashboardLayout.vue?vue&type=script&lang=js"
export * from "./MasterDashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./MasterDashboardLayout.vue?vue&type=style&index=0&id=4f59f84c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f59f84c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VMain})
